import TYPES from './types';
import {getCityRatio} from '~/api/ratio';
import {promiseAction, failAction, ActionError} from '~/misc/dispatch';
import * as api from './api'
import create from '~/misc/create';
import get from 'lodash/get';
import messagePush from '~/misc/messagePush';
import { getBidsLoads } from '~/modules/bids/actions'
import { getMyBookingsAction} from '~/modules/bookings/action'

export const getCatalogs = () => (dispatch, getState) => {
  return promiseAction(
    dispatch,
    getState,
    TYPES.MESSAGEPUSH_CATALOGS_GET,
    api.getCatalogs(getState)
  );
};

export const deleteCatalogs = (type) => (dispatch, getState) => {
  return promiseAction(
    dispatch,
    getState,
    TYPES.MESSAGEPUSH_CATALOGS_DELETE,
    api.deleteCatalogs(getState, type),
    type
  );
};

export const deleteAllCatalogs = () => (dispatch, getState) => {
  const catalogs = getState().messagePush.catalogs;
  const types = catalogs.filter(catalog=>catalog.isCanDelete).map(catalog=>catalog.mainType)
  return promiseAction(
    dispatch,
    getState,
    TYPES.MESSAGEPUSH_CATALOGS_DELETEALL,
    Promise.all(types.map((type)=>api.deleteCatalogs(getState,type)))
  );
};

export const readCatalogs = (type) => (dispatch, getState) => {
  dispatch(create(TYPES.MESSAGEPUSH_CATALOGS_READ_PREV, type))
  return promiseAction(
    dispatch,
    getState,
    TYPES.MESSAGEPUSH_CATALOGS_READ,
    api.readCatalogs(getState, type),
    type,
  );
};

export const readAllCatalogs = () => (dispatch, getState) => {
  const catalogs = getState().messagePush.catalogs;
  const types = catalogs.map(catalog=>catalog.mainType);
  types.map(type=>dispatch(create(TYPES.MESSAGEPUSH_CATALOGS_READ_PREV, type)))
  return promiseAction(
    dispatch,
    getState,
    TYPES.MESSAGEPUSH_CATALOGS_READALL,
    Promise.all(types.map((type)=>api.readCatalogs(getState,type)))
  );
};
export const getMessage = ({type, msgId}) => (dispatch, getState) => {
  return promiseAction(
    dispatch,
    getState,
    TYPES.MESSAGEPUSH_MESSAGE_GET,
    api.getMessage(getState, {type, msgId}),
    type
  );
};

export const deleteMessage = ({msgId, type}) => (dispatch, getState) => {
  return promiseAction(
    dispatch,
    getState,
    TYPES.MESSAGEPUSH_MESSAGE_DELETE,
    api.deleteMessage(getState,msgId),
    {msgId, type}
  );
};

export const getToken = () => (dispatch, getState) => {
  const token = get(getState(), 'user.token');
  return promiseAction(
    dispatch,
    getState,
    TYPES.MESSAGEPUSH_TOKEN_GET,
    api.getToken(getState)
  ).then(
    res=> {
      const {data} = res;
      messagePush.create(data, token)
    }
  )
};

export const getCatalogsByPush = () => (dispatch, getState) =>{
  const { activeCatalog } = getState().messagePush;
  if(activeCatalog) {
    dispatch(getMessage({type:activeCatalog}));
    dispatch(readCatalogs(activeCatalog));
  }
  //to refresh bid/book status when get catalogs
  dispatch(getBidsLoads())
  dispatch(getMyBookingsAction());
  return promiseAction(
    dispatch,
    getState,
    TYPES.MESSAGEPUSH_CATALOGS_GET_BYPUSH,
    api.getCatalogs(getState),
    activeCatalog,
  );
}

export const resetMessage = () => (dispatch) => dispatch(create(TYPES.MESSAGEPUSH_RESET));

export const selectCatalogs = (catalogs) => (dispatch) => dispatch(create(TYPES.MESSAGEPUSH_CATALOGS_SELECT, catalogs));


// WEBPACK FOOTER //
// ./src/pages/MessagePush/state/action.js